"use client";
import { Blog } from "@/lib/@types/api/blog";
import BlogList from "./BlogList";
import BlogListFeatured from "./BlogListFeatured";
import { Pagination, Spin } from "antd";
import { useEffect, useState } from "react";
import { getBlogList } from "@/lib/api/blog";

// 异步获取博客列表，确保是一个 Promise
async function fetchBlogList(
	Params: Blog.GetBlogListParams,
): Promise<{ blogList: Blog.BlogListItem[]; blogCount: number }> {
	try {
		const res = await getBlogList(Params);
		return { blogList: res.detail.blog_list, blogCount: res.detail.blog_filter_count };
	} catch (error) {
		console.error("Error fetching blog list:", error);
		return { blogList: [], blogCount: 0 }; // 如果发生错误，返回一个空数组
	}
}
interface BlogsProps {
	blogLists: Blog.BlogListItem[];
	locale: string;
	search: string;
	currentPage: number;
	total: number;
	pageSize: number;
	params: any;
	isTagSlugIn?: boolean;
	useFeaturedStyle?: boolean; // 是否使用特色样式（两列布局）
}
const BlogContent = ({
	params,
	blogLists,
	locale,
	search,
	currentPage,
	total,
	pageSize: initialPageSize,
	// 博客分类参数的不同
	isTagSlugIn=false,
	useFeaturedStyle=false
}: BlogsProps) => {
	const [currentPageState, setCurrentPageState] = useState(currentPage);
	const [searchLoading, setSearchLoading] = useState(false);
	const [blogList, setBlogList] = useState<Blog.BlogListItem[]>(blogLists);
	const limit = initialPageSize;


	const handlePageChange = (page: number) => {
		setCurrentPageState(page);
		getBlogList(page)
		window.scrollTo({ top: 0, behavior: "smooth" });
	};

	function getBlogList(page=1){

		setSearchLoading(true);
		fetchBlogList({
			lang_code: { lang_code: params.locale },
			page: page,
			limit,
			...(isTagSlugIn
				? { tag_slug_in: [{ slug: params.slug }] }
				: { cls_slug_in: [{ slug: params.slug }] }),
		})
			.then((res) => {
				setBlogList(res.blogList);
			})
			.finally(() => {
				setSearchLoading(false);
			});
	}
	return (
		<>
			{searchLoading ? (
        <div className="flex justify-center w-full">
          <Spin size="large" />
        </div>
			) : (
				<>
					{useFeaturedStyle ? (
						<BlogListFeatured blogList={blogList} />
					) : (
						<BlogList blogList={blogList} />
					)}
					{total > 1 && (
						<div className="mt-6 flex w-full items-center justify-center md:mt-10">
							<Pagination
								current={currentPageState}
								total={total}
								pageSize={limit}
								onChange={handlePageChange}
								showSizeChanger={false}
							/>
						</div>
					)}
				</>
			)}
		</>
	);
};

export default BlogContent;
